module.exports = __webpack_public_path__ + "static/media/pasta-de-diamante.220e403b.jpg";